var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('ValidationObserver', {
    ref: "modal-opt-in",
    attrs: {
      "immediate": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref) {
        var validationFailed = _ref.failed;
        return [_c('b-modal', {
          attrs: {
            "id": "modal-opt-in-mobile-prompt",
            "no-close-on-backdrop": "",
            "no-close-on-esc": "",
            "hide-header-close": "",
            "title": "SMS - MottoMortgage Network Alerts",
            "header-class": "text-center",
            "modal-class": "form-modal modal-title-centered",
            "cancel-title": "Decline",
            "ok-title": "Confirm",
            "ok-disabled": validationFailed || _vm._.isEmpty(_vm.modalMobileNumber),
            "centered": true
          },
          on: {
            "cancel": _vm.handleOptInCancel,
            "ok": _vm.handleOptInOk
          }
        }, [_c('div', [_c('div', {
          staticClass: "mt-4"
        }, [_c('p', {
          staticClass: "p1"
        }, [_vm._v(" Opt in to receive important messages regarding marketing, events, and general information about tools, services, and support of the Motto Mortgage network. Message frequency varies. Text HELP to 58476 or call 866-668-8660 for help, STOP to 58476 to end. Message and Data rates may apply. By opting in, you authorize Motto Mortgage to deliver marketing messages using an automatic telephone dialing system. You are not required to opt in as a condition of purchasing any property, goods, or services. By checking the box below, you agree to the "), _c('RouterLink', {
          staticClass: "button-text text-decoration-none color-primary-blue",
          attrs: {
            "to": {
              name: 'mobileTerms'
            },
            "target": "_blank"
          }
        }, [_vm._v("MOBILE TERMS OF USE")]), _vm._v(" and "), _c('a', {
          staticClass: "button-text text-decoration-none color-primary-blue",
          attrs: {
            "href": "https://www.mottomortgage.com/privacy-policy",
            "target": "_blank"
          }
        }, [_vm._v("Motto Mortgage Privacy Policy")]), _vm._v(" and "), _c('RouterLink', {
          staticClass: "button-text text-decoration-none color-primary-blue",
          attrs: {
            "to": {
              name: 'userAgreement'
            },
            "target": "_blank"
          }
        }, [_vm._v("USER AGREEMENT")]), _vm._v(". ")], 1), _c('div', {
          staticClass: "d-flex mt-3 align-items-center",
          class: _vm.$style.optInMobileNumberContainer
        }, [_c('ValidationProvider', {
          attrs: {
            "name": 'optInMobile'
          }
        }, [_c('FormItemPhone', {
          staticClass: "mt-2 mb-4",
          class: _vm.$style.notificationPhoneSms,
          attrs: {
            "phone-label": "Mobile Number",
            "edit-mode": "",
            "hide-ext": "",
            "disabled": !_vm.hasOptedInSMSModal[0],
            "options": {
              hideAsterisk: true
            },
            "phone-placeholder": "Mobile Number",
            "phone": _vm.modalMobileNumber,
            "rules": 'required|validPhoneNumber'
          },
          on: {
            "update:phone": function updatePhone($event) {
              _vm.modalMobileNumber = $event;
            }
          }
        }), _c('BaseCheckbox', {
          attrs: {
            "label": "I’d like to receive text messages from Motto HQ.",
            "input-value": "1"
          },
          model: {
            value: _vm.hasOptedInSMSModal,
            callback: function callback($$v) {
              _vm.hasOptedInSMSModal = $$v;
            },
            expression: "hasOptedInSMSModal"
          }
        })], 1)], 1)])])])];
      }
    }])
  }), _c('ValidationObserver', {
    ref: "modal-home-opt-in",
    attrs: {
      "immediate": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref2) {
        var validationFailedHome = _ref2.failed;
        return [_c('b-modal', {
          attrs: {
            "id": "modalHomeOptInMobilePrompt",
            "no-close-on-backdrop": "",
            "no-close-on-esc": "",
            "header-close-content": "Skip",
            "modal-class": "form-modal modal-title-centered",
            "cancel-title": "Decline",
            "header-class": "text-center",
            "title": "SMS - MottoMortgage Network Alerts",
            "ok-title": "Confirm",
            "ok-disabled": !_vm.acceptedMobileOptInData[0] || validationFailedHome || _vm._.isEmpty(_vm.modalMobileNumber),
            "centered": true
          },
          on: {
            "close": _vm.handleHomeOptInCancel,
            "cancel": _vm.handleHomeOptInCancel,
            "ok": _vm.handleHomeOptInOk
          }
        }, [_c('div', [_c('div', {
          staticClass: "mt-4"
        }, [_c('p', {
          staticClass: "p1"
        }, [_vm._v(" Opt in to receive important messages regarding marketing, events, and general information about tools, services, and support of the Motto Mortgage network. Message frequency varies. Text HELP to 58476 or call 866-668-8660 for help, STOP to 58476 to end. Message and Data rates may apply. By opting in, you authorize Motto Mortgage to deliver marketing messages using an automatic telephone dialing system. You are not required to opt in as a condition of purchasing any property, goods, or services. By checking the box below, you agree to the "), _c('RouterLink', {
          staticClass: "button-text text-decoration-none color-primary-blue",
          attrs: {
            "to": {
              name: 'mobileTerms'
            },
            "target": "_blank"
          }
        }, [_vm._v("MOBILE TERMS OF USE")]), _vm._v(" and "), _c('a', {
          staticClass: "button-text text-decoration-none color-primary-blue",
          attrs: {
            "href": "https://www.mottomortgage.com/privacy-policy",
            "target": "_blank"
          }
        }, [_vm._v("Motto Mortgage Privacy Policy")]), _vm._v(" and "), _c('RouterLink', {
          staticClass: "button-text text-decoration-none color-primary-blue",
          attrs: {
            "to": {
              name: 'userAgreement'
            },
            "target": "_blank"
          }
        }, [_vm._v("USER AGREEMENT")]), _vm._v(". ")], 1), _c('div', {
          staticClass: "d-flex mt-3 align-items-center",
          class: _vm.$style.optInMobileNumberContainer
        }, [_c('ValidationProvider', {
          attrs: {
            "name": 'optInMobile'
          }
        }, [_c('FormItemPhone', {
          staticClass: "mt-2 mb-4",
          class: _vm.$style.notificationPhoneSms,
          attrs: {
            "phone-label": "Mobile Number",
            "edit-mode": "",
            "hide-ext": "",
            "disabled": !_vm.hasOptedInSMSModal[0],
            "options": {
              hideAsterisk: true
            },
            "phone-placeholder": "Mobile Number",
            "phone": _vm.modalMobileNumber,
            "rules": 'required|validPhoneNumber'
          },
          on: {
            "update:phone": function updatePhone($event) {
              _vm.modalMobileNumber = $event;
            }
          }
        }), _c('BaseCheckbox', {
          attrs: {
            "label": "I’d like to receive text messages from Motto HQ.",
            "input-value": "1"
          },
          model: {
            value: _vm.acceptedMobileOptInData,
            callback: function callback($$v) {
              _vm.acceptedMobileOptInData = $$v;
            },
            expression: "acceptedMobileOptInData"
          }
        })], 1)], 1)])])])];
      }
    }])
  }), _c('b-modal', {
    attrs: {
      "id": "modalPrivacy",
      "no-close-on-backdrop": "",
      "no-close-on-esc": "",
      "hide-header-close": "",
      "title": "Opt-in to Receive text messages from Motto HQ",
      "header-class": "text-center",
      "modal-class": "confirmation-modal",
      "ok-only": "",
      "ok-title": "Ok",
      "centered": true
    },
    on: {
      "ok": _vm.closePrivacyModal
    }
  }, [_c('div', {
    class: _vm.$style.privacyPolicyContainer
  })]), _c('b-modal', {
    attrs: {
      "id": "modalMobileTerms",
      "no-close-on-backdrop": "",
      "no-close-on-esc": "",
      "hide-header-close": "",
      "title": "Opt-in to Receive text messages from Motto HQ",
      "header-class": "text-center",
      "modal-class": "confirmation-modal",
      "ok-only": "",
      "ok-title": "Ok",
      "centered": true
    },
    on: {
      "ok": _vm.closeMobileTermsModal
    }
  }, [_c('div', {
    class: _vm.$style.privacyPolicyContainer
  }, [_c('MobileTerms')], 1)])], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }